import { render, staticRenderFns } from "./FormInput.htm?vue&type=template&id=70842dbd&"
import script from "./FormInput.ts?vue&type=script&lang=js&"
export * from "./FormInput.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports